module.exports = __webpack_public_path__ + "img/05_no.bd3081f1.svg";